/**
 * Not supported on the web
 */
export function SettingsUpdates() {
  return null
}
